import React from 'react';

import { type TScaffoldTableColumnConfig } from '../../components/TScaffoldTableColumnConfig';
import { type TTableBaseRowContext } from '../../components/TTableBaseRowContext';
import CTableBase, { type ITableBaseProps } from './CTableBase';

export default function CTable(props: ITableBaseProps) {
  const defaultRowStyle = (context: TTableBaseRowContext) => {
    return {
      backgroundColor: context.cellCoordinate[1] % 2 === 1 ? 'rgb(0, 0, 0, 0.02)' : 'rgba(0, 0, 0, 0)'
    };
  };

  const defaultCellStyle = {
    minHeight: '4.5rem',
    height: '4rem',
    paddingTop: '0.5rem',
    paddingRight: '1rem',
    paddingBottom: '0.5rem',
    paddingLeft: '1rem'
  };

  return (
    <>
      <CTableBase
        {...props}
        className={(props.rowConfig.body?.link ?? props.rowConfig.body?.onClick) ? 'table-row-highlight-on-hover' : ''}
        rowConfig={{
          ...props.rowConfig,
          body: {
            ...props.rowConfig.body,
            style: (context) => {
              return {
                ...defaultRowStyle(context),
                ...props.rowConfig.body?.style?.(context)
              };
            }
          }
        }}
        columnConfig={Array(Object.keys(props.data ?? {}).length)
          .fill(undefined)
          .map((_, ix) => {
            return {
              ...(props.columnConfig?.[ix] ?? {}),
              header: {
                ...props.columnConfig?.[ix]?.header,
                style: (context) => {
                  return {
                    fontWeight: 'bold',
                    textAlign: 'center',
                    ...defaultCellStyle,
                    ...props.columnConfig?.[ix]?.header?.style?.(context)
                  };
                }
              },
              body: {
                ...props.columnConfig?.[ix]?.body,
                style: (context) => {
                  return {
                    ...defaultCellStyle,
                    ...props.columnConfig?.[ix]?.body?.style?.(context)
                  };
                }
              }
            };
          })}
        edgeColumnConfig={{
          ...(props.edgeColumnConfig?.prefix
            ? {
                prefix: {
                  ...props.edgeColumnConfig?.prefix,
                  header: {
                    ...props.edgeColumnConfig.prefix.header,
                    render: (context) => <>{props.edgeColumnConfig?.prefix?.header?.render?.(context)}</>,
                    style: (context) => {
                      return {
                        ...defaultCellStyle,
                        ...props.edgeColumnConfig?.prefix?.header?.style?.(context)
                      };
                    }
                  },
                  body: {
                    ...props.edgeColumnConfig.prefix.body,
                    render: (context) => <>{props.edgeColumnConfig?.prefix?.body?.render?.(context)}</>,
                    style: (context) => {
                      return {
                        ...defaultCellStyle,
                        ...props.edgeColumnConfig?.prefix?.body?.style?.(context)
                      };
                    }
                  }
                } satisfies TScaffoldTableColumnConfig
              }
            : {}),
          ...(props.edgeColumnConfig?.suffix
            ? {
                suffix: {
                  ...props.edgeColumnConfig?.suffix,
                  header: {
                    ...props.edgeColumnConfig.suffix.header,
                    render: (context) => <>{props.edgeColumnConfig?.suffix?.header?.render?.(context)}</>,
                    style: (context) => {
                      return {
                        ...defaultCellStyle,
                        ...props.edgeColumnConfig?.suffix?.header?.style?.(context)
                      };
                    }
                  },
                  body: {
                    ...props.edgeColumnConfig.suffix.body,
                    render: (context) => <>{props.edgeColumnConfig?.suffix?.body?.render?.(context)}</>,
                    style: (context) => {
                      return {
                        ...defaultCellStyle,
                        ...props.edgeColumnConfig?.suffix?.body?.style?.(context)
                      };
                    }
                  }
                } satisfies TScaffoldTableColumnConfig
              }
            : {})
        }}
      />
    </>
  );
}
